import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { sparkPlayApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { SparkPlayFormData } from '../types/spark-play';

export function useSparkPlays() {
  return useQuery({
    queryKey: queryKeys.sparkPlays.list(),
    queryFn: () => sparkPlayApi.listPlays(),
  });
}

export function useUpdateSparkPlay() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: SparkPlayFormData }) =>
      sparkPlayApi.updatePlay(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.sparkPlays.lists() }),
  });
}
